import equipmentSwap from "./index.vue";
export default {
    name: 'equipment-swap',
    path: '/equipment-swap',
    components: {
        app: equipmentSwap,
    },
}
